import { useEffect } from 'react';
export function useDialogFocus(active, onEscape) {
    useEffect(() => {
        if (!active) return undefined;
        const opener = document.activeElement;
        const dialog = [...document.querySelectorAll('[role="dialog"]')].pop();
        if (!dialog) return undefined;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const controls = () => [...dialog.querySelectorAll('button,a[href],input,select,textarea,[tabindex]')].filter(el => !el.matches(':disabled') && el.tabIndex >= 0 && el.getClientRects().length);
        dialog.tabIndex = -1;
        (controls()[0] || dialog).focus();
        const key = event => {
            if (event.key === 'Escape' && onEscape) {
                event.preventDefault();
                onEscape();
                return;
            }
            if (event.key !== 'Tab') return;
            const items = controls();
            if (!items.length) {
                event.preventDefault();
                dialog.focus();
                return;
            }
            const currentIndex = items.indexOf(document.activeElement);
            const nextIndex = event.shiftKey
                ? currentIndex <= 0 ? items.length - 1 : currentIndex - 1
                : currentIndex < 0 || currentIndex === items.length - 1 ? 0 : currentIndex + 1;
            event.preventDefault();
            items[nextIndex].focus();
        };
        const contain = event => { if (!dialog.contains(event.target)) (controls()[0] || dialog).focus(); };
        document.addEventListener('focusin',contain,true);
        document.addEventListener('keydown',key,true);
        return () => { document.removeEventListener('focusin',contain,true); document.removeEventListener('keydown',key,true); document.body.style.overflow = previousOverflow; if (opener?.isConnected) opener.focus(); };
    },[active, onEscape]);
}
